<template>
  <b-modal
    class="agenda-configure-timeslot"
    id="agenda-configure-timeslot"
    ref="modal"
    title="Configurar Hueco"
    hide-footer
  >
    <div class="form-group row">
      <div class="col-sm-12">
        <legend style="text-transform: uppercase">{{ legend }}</legend>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-6">
        <div class="d-flex align-items-center">
          <select
            name="type"
            id="config_timeslot_category_id"
            v-model="product_category_id"
            class="custom-select"
            required
          >
            <option :value="null">Ninguna</option>
            <option v-for="(c, i) in categories" :key="i" :value="c.id">
              {{ c.name }}
            </option>
          </select>
          <div
            v-if="product_category_id"
            class="product-category-color ml-3"
            :style="product_category_style"
          ></div>
        </div>
        <label class="wabident-info" for="config_timeslot_category_id"
          >Familia / Categoría / Unidad Médica</label
        >
      </div>
      <div class="col-sm-6">
        <input
          v-model="notes"
          type="text"
          class="form-control"
          id="agenda_timeslot_notes"
        />
        <label for="agenda_timeslot_notes" class="wabident-info">Notas</label>
      </div>
    </div>

    <div class="form-group row mt-5">
      <div class="col text-center">
        <button
          :disabled="is_loading"
          @click="onDelete"
          class="btn btn-wabident-delete float-left"
          style="width: 53.6px; height: 53.6px"
        ></button>
        <button
          :disabled="is_loading"
          type="button"
          @click="onSubmit"
          class="btn btn-primary btn-wabident float-right"
        >
          <span v-if="is_loading">Guardando&nbsp;</span>
          <span v-else>Guardar</span>
          <i v-if="is_loading" class="fas fa-circle-notch float-right"></i>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      is_loading: false,
      timeslot: null,
      box: null,
      product_hierarchy: [],
      product_category_id: null,
      notes: null,
    };
  },
  computed: {
    product_category_style() {
      const color = this.colordict[this.product_category_id] || null;

      return {
        "background-color": color,
      };
    },
    weekdays() {
      return moment.weekdays();
    },
    weekday() {
      return this.weekdays[this.day];
    },
    day() {
      if (this.timeslot) {
        const d = moment(this.timeslot.from);
        return d.day();
      }
      return 0;
    },
    categories() {
      let ret = [];

      this.product_hierarchy.forEach((cat) => {
        this.addCategory(cat, ret, 0);
      });

      return ret;
    },
    colordict() {
      let ret = {};

      this.categories.forEach((cat) => {
        console.log(cat);
        ret[cat.id] = cat.color;
      });

      console.log(ret);
      return ret;
    },
    legend() {
      if (this.timeslot) {
        const d = moment(this.timeslot.from);
        return this.weekday + " " + d.format("HH:mm");
      }
      return "";
    },
    ...mapGetters(["clinic", "msgwindow"]),
  },
  methods: {
    show(timeslot, box, tsconfig) {
      this.is_loading = false;
      this.timeslot = timeslot;
      this.box = box;
      this.product_category_id = tsconfig ? tsconfig.product_category_id : null;
      this.notes = tsconfig ? tsconfig.notes : null;
      this.$refs.modal.show();
    },
    getCategories() {
      axios
        .get("/product/hierarchy")
        .then((response) => {
          this.product_hierarchy = response.data;
        })
        .catch((err) => {
          console.log("[ERR] getCategories", err);
          this.msgwindow.error("Error buscando categorías de productos");
        });
    },
    addCategory(cat, ret, level) {
      let prefix = "⁠–".repeat(level);

      ret.push({
        id: cat.id,
        slug: cat.slug,
        name: prefix + cat.name,
        parent_id: cat.parent_id,
        color: cat.color,
        level: level,
      });

      cat.children.forEach((subcat) => {
        this.addCategory(subcat, ret, level + 1);
      });
    },
    onSubmit() {
      if (this.is_loading) {
        return;
      }

      this.is_loading = true;

      axios
        .post(`/clinic/${this.clinic.id}/timeslot_config`, {
          day: this.day,
          hour: this.timeslot.hour,
          minute: this.timeslot.minute,
          box: this.box.id,
          product_category_id: this.product_category_id,
          notes: this.notes,
        })
        .then((response) => {
          this.$set(this.clinic.schedule, "timeslot_config", response.data);
        })
        .catch((error) => {
          console.log("[ERR] saveTimeslotConfig", error);
          this.msgwindow.error("Error guardando configuración");
        })
        .then(() => {
          this.is_loading = false;
          this.$refs.modal.hide();
        });
    },
    onDelete() {
      if (this.is_loading) {
        return;
      }

      this.is_loading = true;

      axios
        .post(`/clinic/${this.clinic.id}/timeslot_config`, {
          _method: "delete",
          day: this.day,
          hour: this.timeslot.hour,
          minute: this.timeslot.minute,
          box: this.box.id,
        })
        .then((response) => {
          this.$set(this.clinic.schedule, "timeslot_config", response.data);
        })
        .catch((error) => {
          console.log("[ERR] deleteTimeslotConfig", error);
          this.msgwindow.error("Error guardando configuración");
        })
        .then(() => {
          this.is_loading = false;
          this.$refs.modal.hide();
        });
    },
  },
  mounted() {
    this.getCategories();
  },
};
</script>

<style lang="scss">
#agenda-configure-timeslot {
  .product-category-color {
    width: 30px;
    height: 30px;
    flex: 0 0 30px;
    display: block;
    border-radius: 5px;
  }
}
</style>
